import type { CycleEvaluationGroup } from '@/types/cycle-evaluation/CycleEvaluationGroup';

import { api } from '@/api/api';

export interface CycleEvaluationGroupDeletionImpact {
    generatedEvaluationsCount: number;
    scheduledEmailsCount: number;
}

export interface CycleEvaluationGroupReminderRecipients {
    nonRespondentCount: number;
    hasGeneratedEvaluations: boolean;
}

export interface CycleEvaluationGroupReactivationImpact {
    skippedMilestonesCount: number;
    skippedRemindersCount: number;
}

export default {
    async getCycleEvaluationGroup(id: string): Promise<CycleEvaluationGroup> {
        const response = await api.get(`/cycleevaluationgroup/${id}`);

        return response.data;
    },

    async getCycleEvaluationGroupList(): Promise<CycleEvaluationGroup[]> {
        const response = await api.get('/cycleevaluationgroup');

        return response.data;
    },

    async getCycleEvaluationGroupDeletionImpact(
        id: string,
    ): Promise<CycleEvaluationGroupDeletionImpact> {
        const response = await api.get(`/cycleevaluationgroup/${id}/deletion-impact`);

        return response.data;
    },

    async getCycleEvaluationGroupReminderRecipients(
        id: string,
    ): Promise<CycleEvaluationGroupReminderRecipients> {
        const response = await api.get(`/cycleevaluationgroup/${id}/reminder-recipients`);

        return response.data;
    },

    async getCycleEvaluationGroupReactivationImpact(
        id: string,
    ): Promise<CycleEvaluationGroupReactivationImpact> {
        const response = await api.get(`/cycleevaluationgroup/${id}/reactivation-impact`);

        return response.data;
    },
};
